
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"

function NameSetting ({socket}){
  const location = useLocation ();
  const [name,setName] = useState (location.state.name);
  const navigate = useNavigate ();
  useEffect (()=>{
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
      <div style={style.content}>
        <h2 style={style.text}>
          تنظیم نام سیستم
        </h2>
        <input style={style.input}
        type="text"
        placeholder = ""
        value={name}
        onChange = {(e)=>{setName (e.target.value)}}/>
    </div>
    <button className="btn"
      onClick ={()=>{
      socket.off ('message');
      socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="SAVE_NAME" && JSON.parse(data).data==true)
            {
              window.alert ('اطلاعات با موفقیت ذخیره شد');
              socket.off ('message');
              navigate (-1);
            }
        });
        SendData (socket,'data',{"event":"set_name","data":{"name":name}});
      }}>
       تایید
    </button>
    </div>
  );


}
const style={
  container:{
    width:"90%",
    minHeight:"100vh",
//    display:"flex",
    alignItems:"center",
    padding:10,

//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
     maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10,
    padding:10,
    backgroundColor:"#00afff",
    borderRadius:8
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:20,
    borderRadius:8,
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:820,
    padding:4,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    padding:0,
    margin:10,
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default NameSetting;
